
import { useEffect, useState } from "react";
import Grid from "../components/general/Grid";
import SlideMenu from "../components/general/SlideMenu";

export default function SpeciesPage(props) {
  const { speciesConfig, setColorBg, setLogoHeader, setShowSpecies } = props;

  useEffect(() => {
    setColorBg(speciesConfig.color);
    setLogoHeader(speciesConfig.header);
    setShowSpecies(false);
  }, [speciesConfig, setColorBg, setLogoHeader, setShowSpecies]);

  const [open, setOpen] = useState(false);
  const [contentSlideMenu, setContentSlideMenu] = useState();

  const openMenu = () => {
    setOpen(true);
  };

  return (
    <>
      <div className="text-center">
        <SlideMenu
          open={open}
          setOpen={setOpen}
          content={contentSlideMenu}
        ></SlideMenu>
        <Grid
          openMenu={openMenu}
          setContentSlideMenu={setContentSlideMenu}
          ConfigVar={speciesConfig}
        />
      </div>
    </>
  );
}
